<template>
  <div class="RnDownload">
    <div class="nav">
      <div class="nav-left"><img src="./images/qqc_logo@2x.png" alt=""></div>
      <div class="nav-right">
        <p>青青草</p>
        <p>苹果永久版</p>
        <p @click="downloadBtn"><img src="./images/btn_download@2x.png" alt=""></p>
      </div>
    </div>
    
    <div class="color-band"></div>
    <div class="iphoneuse"><img src="./images/img_iphoneuse@2x.png" alt=""></div>
    <p class="text-one">用心做，用爱做，有让TA翻云覆雨的能力，才能让TA不兴风作浪的权利，青青草视频，十年沉淀只做精品，不辜负每一份热爱。</p>
    <p class="line"></p>
    <div class="install-nav"><img src="./images/img_tutorial@2x.png" alt=""></div>
  </div>
</template>

<script>
export default {
  props: {
    RnKey: {
      type: String,
    },
  },
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
    downloadBtn() {
      // 埋点
      this.$sensors.track('LandingPage', {
      method: 'download',
      pid: 'M05',
      ldy_type: 'original',
      type: 'RN'
    });
      this.$emit("downloadRn");
    },
  },
};
</script>

<style lang="scss" scoped>
.RnDownload {
  padding: 0 16px;
  .nav {
    margin: 20px 0;
    display: flex;
    align-items: center;
    height: 130px;
    .nav-left {
      img {
        width: 108px;
        height: 108px;
        object-fit: cover;
      }
    }
    .nav-right {
      margin-left: 14px;
      :first-child {
        font-size: 20px;
        color: #000000;
        font-weight: 600;
      }
      :nth-child(2) {
        font-size: 14px;
        color: #8A898D;
        padding-top: 4px;
      }
      img {
        margin-top: 30px;
        width: 92px;
        height: 26px;
        object-fit: cover;
      }
    }
  }
  .iphoneuse {
    margin:10px 0 ;
    img {
      width: 110px;
      height: 24px;
      object-fit: cover;
    }
  }
  .text-one {
    font-size: 14px;
    color: #000000;
    font-family: PingFangSC-Regular;
    margin-top: 10px;
  }
  .line {
    border: 0.1px solid #f7f5f8;
    width: 339px;
    margin-top: 20px;
    
  }
  .install-nav {
    width: 343px;
    height: 983px;
    margin-top:22px ;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .color-band {
    width: 339px;
    height: 94px;
    background: url("./images/img_details@2x.png") no-repeat;
    background-size: cover;
    margin-top: 10px;
  }
}
</style>